import cn from 'classnames';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import { OrderItem } from 'gql/graphql';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isDesktop from 'store/app/selector/isDesktop';
import BasketItemPreview from '../BasketItemPreview/BasketItemPreview';
import BasketItemQuantitySelector from '../BasketItemSelectors/BasketItemQuantitySelector/BasketItemQuantitySelector';
import BasketItemSelectors from '../BasketItemSelectors/BasketItemSelectors';
import { BasketItemAttr } from '../BasketMain/types';
import styles from './BasketItem.module.scss';

interface BasketItemProps {
  onRemoveItem: (orderItemId: number) => void;
  onEditItem: (orderItemId: number) => void;
  onChangeSelector: (orderItemId: number, attr: BasketItemAttr) => void;
  item: OrderItem;
  loading: boolean;
}

const BasketItem: React.FC<BasketItemProps> = ({ item, loading }) => {
  const { t } = useTranslation();
  const isDesktopDevice = useSelector(isDesktop);

  return (
    <div
      className={cn(styles.cartItem, {
        [styles.loading]: loading,
      })}
    >
      {isDesktopDevice && <BasketItemPreview thumbnailUrl={item.thumbnailUrl || ''} />}
      {!isDesktopDevice && (
        <div className={styles.mobilePreviewQty}>
          <BasketItemPreview thumbnailUrl={item.thumbnailUrl || ''} />
          <div className={styles.quantity}>
            <BasketItemQuantitySelector
              quantities={item.quantityOptions}
              onChangeSelector={() => {}}
              orderItemId={1}
              selector={{} as BasketItemAttr}
            />
          </div>
        </div>
      )}
      <div className={styles.detalsColumn}>
        <div className={styles.details}>
          <div className={styles.heading}>
            <div className={styles.title}>
              <OpText variant={isDesktopDevice ? 'body' : 'title'} size={isDesktopDevice ? 'large' : 'small'}>
                {item?.name || 'Placeholder title'}
              </OpText>
              {!isDesktopDevice && <OpIcon icon="dots-vertical" size="small" />}
            </div>
            <div className={styles.headingSection}>
              <div className={styles.price}>
                <div
                  className={styles.priceInitial}
                  dangerouslySetInnerHTML={{ __html: item?.price?.initial?.formatted || '' }}
                />
                <div
                  className={styles.priceDiscounted}
                  dangerouslySetInnerHTML={{ __html: item?.price?.discount?.formatted || '' }}
                />
              </div>
              {isDesktopDevice && <OpIcon icon="dots-vertical" size="small" />}
            </div>
          </div>
          <div className={styles.categoryName}>
            <OpText variant="body" size="small">
              {item?.description || 'Placeholder category name'}
            </OpText>
          </div>

          {isDesktopDevice && (
            <div className={styles.quantity}>
              <BasketItemQuantitySelector
                quantities={item.quantityOptions}
                onChangeSelector={() => {}}
                orderItemId={1}
                selector={{} as BasketItemAttr}
              />
            </div>
          )}
        </div>

        <BasketItemSelectors
          orderItemId={item.orderItemId}
          appliedItemSelectors={['FRAMES', 'ENVELOPES']}
          onChangeSelector={() => {}}
        />

        {isDesktopDevice && (
          <div className={styles.delete}>
            <OpIcon icon="trash" size="small" />
            <OpText variant="body" size="medium">
              {t('txt_delete')}
            </OpText>
          </div>
        )}
      </div>
    </div>
  );
};

export default BasketItem;
